@if (link.type !== 5) {
    <div class="link">
        @if (shouldOpenInModal) {
            <img (click)="onTap()" alt="Link" class="grow" src="{{ imageUrl }}"/>
        }
        @if (!shouldOpenInModal) {
            <a [attr.href]="link.url" appDigi4SchoolValidation target="_blank">
                <img (click)="onLinkClick()" alt="Link" class="grow" src="{{ imageUrl }}"/>
            </a>
        }
    </div>
}


@if (link.type === 5) {
    <div [class.opac0]="!link.isSolutionLink"
         [class.solution-area]="link.isSolutionLink"
         class="link link-area">
        @if (shouldOpenInModal) {
            <a (click)="onTap()">
                @if (imageUrl) {
                    <img (click)="onLinkClick()" alt="Link" class="grow" src="{{ imageUrl }}"/>
                }
            </a>
        }
        @if (!shouldOpenInModal) {
            <a [attr.href]="link.url" appDigi4SchoolValidation target="_blank">
                @if (imageUrl) {
                    <img (click)="onLinkClick()" alt="Link" class="grow" src="{{ imageUrl }}"/>
                }
            </a>
        }
    </div>
}
